import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VbRecurringPaymentInstructionCard } from '../../../interfaces/vb-recurring-payment-instruction-card';

@Component({
  selector: 'app-vb-payment-change-recurring-payment-instruction-card',
  templateUrl: './vb-payment-change-recurring-payment-instruction-card.component.html',
  styleUrls: ['./vb-payment-change-recurring-payment-instruction-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeRecurringPaymentInstructionCardComponent {
  @Input({ required: true }) card!: VbRecurringPaymentInstructionCard;
  @Input() showStatusPill: boolean = false;
}
